<template>
  <div id="empty-layout">
    <v-app id="empty-app">
      <v-main>
        <v-container class="fill-height" fluid>
          <v-row>
            <v-col cols="12">
              <slot></slot>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>

<script>
export default {
  name: "empty-layout"
};
</script>

<style lang="scss">
</style>
